import sc from 'styled-components';

import React from 'react';
export default sc.div`
  width: 100%;
   display: flex;
    justify-content: center; 
    align-items: baseline;
    `;
